module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), _vm._v(" "), _c('vuetable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "showEdit": true,
      "showDelete": true,
      "tableData": _vm.documentData,
      "table-title": "Documents",
      "fields": [{
        header: 'Name',
        prop: 'name',
        hideByDefault: false
      }, {
        header: 'Code',
        prop: 'code',
        hideByDefault: false
      }],
      "maxItems": _vm.maxValue
    },
    on: {
      "table-delete-request": _vm.deleteEntity,
      "table-edit-request": _vm.handleEdit,
      "pages-remaining": _vm.loadMore
    },
    scopedSlots: _vm._u([{
      key: "icons",
      fn: function(maiScope) {
        return _c('div', {
          staticClass: "btn btn-primary",
          attrs: {
            "data-toggle": "tooltip",
            "title": "Download"
          },
          on: {
            "click": function($event) {
              return _vm.popup(maiScope.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cbb2367a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/Document/DocumentSearchResults.vue
// module id = 2279
// module chunks = 1